/**
 * Ask the browser not to evict this origin's storage.
 *
 * The Supabase refresh token lives in localStorage, which browsers class as
 * "best-effort" storage and are free to clear under disk pressure — and mobile
 * is exactly where that pressure exists. For an installed PWA the symptom is
 * indistinguishable from an expired login: the app opens, the token is simply
 * gone, and the student is asked to sign in again for no visible reason.
 *
 * Granting is entirely the browser's call and needs no permission prompt in
 * practice: Chrome grants it automatically to installed PWAs and to
 * sufficiently engaged sites, and Safari grants it to home-screen web apps.
 * A refusal is not an error — storage just stays best-effort, exactly as it is
 * today. Nothing in the app depends on the outcome, so this is fire-and-forget.
 */
export function requestPersistentStorage(): void {
  const storage = navigator.storage as StorageManager | undefined;
  if (storage === undefined || typeof storage.persist !== 'function') return;

  void storage
    .persisted()
    .then(async (already) => (already ? true : storage.persist()))
    .catch(() => false);
}
